import { composeThemeFromProps, Compose } from '@css-modules-theme/react';
import 'react';
import { AccordionProvider } from './context/AccordionProvider.js';
import defaultStyles from './styles/Accordion.module.scss.js';
import { jsx } from 'react/jsx-runtime';

const Accordion = props => {
  const {
    children,
    multiple,
    value,
    defaultValue,
    onChange,
    transitionDuration,
    disableChevronRotation,
    expandIconPosition,
    expandIcon,
    collapseIcon,
    theme,
    variant,
    ...rest
  } = props;
  const styles = composeThemeFromProps(defaultStyles, {
    theme
  }, {
    compose: Compose.Merge
  });
  return /*#__PURE__*/jsx(AccordionProvider, {
    multiple: multiple,
    value: value,
    defaultValue: defaultValue,
    onChange: onChange,
    transitionDuration: transitionDuration,
    disableChevronRotation: disableChevronRotation,
    expandIconPosition: expandIconPosition,
    expandIcon: expandIcon,
    variant: variant,
    collapseIcon: collapseIcon,
    children: /*#__PURE__*/jsx("div", {
      ...rest,
      "data-accordion": true,
      className: styles.root,
      children: children
    })
  });
};
Accordion.displayName = 'Accordion';

export { Accordion };
